module.exports = __webpack_public_path__ + "static/feature3-56d34610feae7fa54c7ccaf5c49bb46d.png";